import React from "react";
import { Card, Row, Col, Typography, Grid, Button } from "antd";
import { useIntl } from "react-intl";
import {
  CreditCardOutlined,
  BankOutlined,
  SafetyOutlined,
  IdcardOutlined,
  GiftOutlined,
  WalletOutlined,
  DollarOutlined,
  MoneyCollectOutlined,
  SecurityScanOutlined,
  UserOutlined,
  TeamOutlined,
  CustomerServiceOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  ToolOutlined,
  FileTextOutlined,
  PhoneOutlined,
  MailOutlined,
  GlobalOutlined,
  LockOutlined,
  UnlockOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  StarOutlined,
  HeartOutlined,
  TrophyOutlined,
  CrownOutlined,
  FireOutlined,
  ThunderboltOutlined,
  RocketOutlined,
  BulbOutlined,
  BookOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
  HomeOutlined,
  ShopOutlined,
  CarOutlined,
  CameraOutlined,
  PictureOutlined,
  VideoCameraOutlined,
  SoundOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
  StopOutlined,
  DownloadOutlined,
  UploadOutlined,
  ShareAltOutlined,
  LinkOutlined,
  CopyOutlined,
  SaveOutlined,
  ReloadOutlined,
  SyncOutlined,
  LoadingOutlined,
  SearchOutlined,
  FilterOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  KeyOutlined,
  DatabaseOutlined,
  CloudOutlined,
  WifiOutlined,
  MobileOutlined,
  TabletOutlined,
  DesktopOutlined,
  LaptopOutlined,
  PrinterOutlined,
  ScanOutlined,
  QrcodeOutlined,
  BarcodeOutlined,
  TagOutlined,
  TagsOutlined,
  FlagOutlined,
  PushpinOutlined,
  CompassOutlined,
  AimOutlined,
  SunOutlined,
  MoonOutlined,
  CloudSyncOutlined,
  CloudUploadOutlined,
  CloudDownloadOutlined,
  CloudServerOutlined,
} from "@ant-design/icons";
import type { Category, CategoryConfig } from "../../types/category";
import { createUCCategoryPrevewStyles } from "../../styles/uchat/UCCategoryPrevew.styles";
import type { ThemeColors } from "./UCIndependentChat/hooks/useTheme";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

// 图标映射
const ICON_MAP: Record<string, React.ReactNode> = {
  CreditCardOutlined: <CreditCardOutlined />,
  BankOutlined: <BankOutlined />,
  SafetyOutlined: <SafetyOutlined />,
  IdcardOutlined: <IdcardOutlined />,
  GiftOutlined: <GiftOutlined />,
  WalletOutlined: <WalletOutlined />,
  DollarOutlined: <DollarOutlined />,
  MoneyCollectOutlined: <MoneyCollectOutlined />,
  SecurityScanOutlined: <SecurityScanOutlined />,
  UserOutlined: <UserOutlined />,
  TeamOutlined: <TeamOutlined />,
  CustomerServiceOutlined: <CustomerServiceOutlined />,
  QuestionCircleOutlined: <QuestionCircleOutlined />,
  SettingOutlined: <SettingOutlined />,
  ToolOutlined: <ToolOutlined />,
  FileTextOutlined: <FileTextOutlined />,
  PhoneOutlined: <PhoneOutlined />,
  MailOutlined: <MailOutlined />,
  GlobalOutlined: <GlobalOutlined />,
  LockOutlined: <LockOutlined />,
  UnlockOutlined: <UnlockOutlined />,
  CheckCircleOutlined: <CheckCircleOutlined />,
  CloseCircleOutlined: <CloseCircleOutlined />,
  ExclamationCircleOutlined: <ExclamationCircleOutlined />,
  StarOutlined: <StarOutlined />,
  HeartOutlined: <HeartOutlined />,
  TrophyOutlined: <TrophyOutlined />,
  CrownOutlined: <CrownOutlined />,
  FireOutlined: <FireOutlined />,
  ThunderboltOutlined: <ThunderboltOutlined />,
  RocketOutlined: <RocketOutlined />,
  BulbOutlined: <BulbOutlined />,
  BookOutlined: <BookOutlined />,
  CalendarOutlined: <CalendarOutlined />,
  ClockCircleOutlined: <ClockCircleOutlined />,
  EnvironmentOutlined: <EnvironmentOutlined />,
  HomeOutlined: <HomeOutlined />,
  ShopOutlined: <ShopOutlined />,
  CarOutlined: <CarOutlined />,
  CameraOutlined: <CameraOutlined />,
  PictureOutlined: <PictureOutlined />,
  VideoCameraOutlined: <VideoCameraOutlined />,
  SoundOutlined: <SoundOutlined />,
  PlayCircleOutlined: <PlayCircleOutlined />,
  PauseCircleOutlined: <PauseCircleOutlined />,
  StopOutlined: <StopOutlined />,
  DownloadOutlined: <DownloadOutlined />,
  UploadOutlined: <UploadOutlined />,
  ShareAltOutlined: <ShareAltOutlined />,
  LinkOutlined: <LinkOutlined />,
  CopyOutlined: <CopyOutlined />,
  SaveOutlined: <SaveOutlined />,
  ReloadOutlined: <ReloadOutlined />,
  SyncOutlined: <SyncOutlined />,
  LoadingOutlined: <LoadingOutlined />,
  SearchOutlined: <SearchOutlined />,
  FilterOutlined: <FilterOutlined />,
  SortAscendingOutlined: <SortAscendingOutlined />,
  SortDescendingOutlined: <SortDescendingOutlined />,
  EyeOutlined: <EyeOutlined />,
  EyeInvisibleOutlined: <EyeInvisibleOutlined />,
  KeyOutlined: <KeyOutlined />,
  DatabaseOutlined: <DatabaseOutlined />,
  CloudOutlined: <CloudOutlined />,
  WifiOutlined: <WifiOutlined />,
  MobileOutlined: <MobileOutlined />,
  TabletOutlined: <TabletOutlined />,
  DesktopOutlined: <DesktopOutlined />,
  LaptopOutlined: <LaptopOutlined />,
  PrinterOutlined: <PrinterOutlined />,
  ScanOutlined: <ScanOutlined />,
  QrcodeOutlined: <QrcodeOutlined />,
  BarcodeOutlined: <BarcodeOutlined />,
  TagOutlined: <TagOutlined />,
  TagsOutlined: <TagsOutlined />,
  FlagOutlined: <FlagOutlined />,
  PushpinOutlined: <PushpinOutlined />,
  CompassOutlined: <CompassOutlined />,
  AimOutlined: <AimOutlined />,
  SunOutlined: <SunOutlined />,
  MoonOutlined: <MoonOutlined />,
  CloudSyncOutlined: <CloudSyncOutlined />,
  CloudUploadOutlined: <CloudUploadOutlined />,
  CloudDownloadOutlined: <CloudDownloadOutlined />,
  CloudServerOutlined: <CloudServerOutlined />,
};

interface CategoryReplyPreviewProps {
  categoryData?: Category;
  onCategorySelect?: (config: CategoryConfig) => void;
  onStartWithoutCategory?: () => void;
  selectedCategory?: CategoryConfig;
  userName?: string;
  mode?: "full" | "simple"; // simple: 只展示 name，用于切换分类
  themeColors?: ThemeColors;
  toggleTheme?: () => void;
  isDark?: boolean;
}

const CategoryReplyPreview: React.FC<CategoryReplyPreviewProps> = ({
  categoryData,
  onCategorySelect,
  onStartWithoutCategory,
  selectedCategory,
  userName,
  mode = "full",
  themeColors,
  toggleTheme,
  isDark,
}) => {
  const intl = useIntl();
  const screens = useBreakpoint();
  const colors = themeColors || {
    background: "#fff",
    text: "#333",
    textSecondary: "#9aa3b2",
    border: "#ececec",
    borderSecondary: "#d9d9d9",
    hoverBg: "#e6f7ff",
    hoverText: "#1890ff",
    senderBg: "#fff",
    senderBorder: "#ececec",
    senderPlaceholder: "#9aa3b2",
    messageBg: "#fff",
    evaluationBg: "#f6ffed",
    evaluationBorder: "#d9f7be",
    evaluationText: "#52c41a",
    evaluationMeta: "#1890ff",
    evaluationFeedbackBg: "rgba(255, 255, 255, 0.8)",
    evaluationFeedbackBorder: "#e8f4fd",
    evaluationFeedbackText: "#262626",
    evaluationSkippedBg: "#fafafa",
    evaluationSkippedBorder: "#d9d9d9",
    evaluationSkippedText: "#8c8c8c",
    shadow: "rgba(0, 0, 0, 0.04)",
    shadowStrong: "rgba(0, 0, 0, 0.1)",
    removeButtonBg: "rgba(0, 0, 0, 0.45)",
    removeButtonBgHover: "rgba(0, 0, 0, 0.65)",
    imageLoadingBg: "rgba(255, 255, 255, 0.8)",
  };
  const styles = createUCCategoryPrevewStyles(screens, colors);
  const displayData = categoryData;
  const hasConfigs = displayData?.configs && displayData.configs.length > 0;

  const handleCategoryClick = (config: CategoryConfig) => {
    onCategorySelect?.(config);
  };

  // 简洁模式：仅展示 name 作为选项按钮
  if (mode === "simple") {
    return (
      <div style={{ padding: 12 }}>
        <div
          style={{
            border: "1px solid #e6e6e6",
            borderRadius: 8,
            padding: 16,
            background: "#fff",
          }}
        >
          {hasConfigs && (
            <Row gutter={[12, 12]}>
              {(displayData!.configs || []).map((config, index) => {
                const isSelected = selectedCategory?.name === config.name;
                return (
                  <Col xs={24} sm={12} md={12} lg={12} key={index}>
                    <Button
                      block
                      type={isSelected ? "primary" : "default"}
                      onClick={() => handleCategoryClick(config)}
                      style={{ height: 40, borderRadius: 8 }}
                    >
                      {config.name}
                    </Button>
                  </Col>
                );
              })}
            </Row>
          )}
          {onStartWithoutCategory && (
            <Button
              block
              type={hasConfigs ? "default" : "primary"}
              onClick={onStartWithoutCategory}
              style={{
                height: 40,
                borderRadius: 8,
                marginTop: hasConfigs ? 12 : 0,
              }}
            >
              {intl.formatMessage({
                id: "chat.direct_chat",
                defaultMessage: "直接开始对话",
              })}
            </Button>
          )}
        </div>
      </div>
    );
  }

  // 默认：完整模式
  return (
    <div style={styles.container}>
      <div style={styles.contentContainer}>
        {userName ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: screens.xs ? 8 : 12,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Title
                level={4}
                style={{
                  margin: 0,
                  color: `${colors.text} !important`,
                  fontWeight: 500,
                  fontSize: screens.xs ? 16 : 18,
                }}
              >
                <span style={{ color: colors.text }}>{`Hi~${userName}`}</span>
              </Title>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {/* 主题切换按钮 */}
              {toggleTheme && (
                <Button
                  type="text"
                  size="large"
                  icon={
                    isDark ? (
                      <BulbOutlined
                        style={{ fontSize: 20, color: colors.text }}
                      />
                    ) : (
                      <MoonOutlined
                        style={{ fontSize: 20, color: colors.text }}
                      />
                    )
                  }
                  onClick={toggleTheme}
                  style={{ width: 40, height: 40 }}
                />
              )}
              <div
                style={{
                  width: screens.xs ? 40 : 48,
                  height: screens.xs ? 40 : 48,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width={screens.xs ? 40 : 48}
                  height={screens.xs ? 40 : 48}
                  viewBox="0 0 18 15"
                  style={{ display: "block" }}
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g transform="translate(-3.000000, -5.000000)">
                      <rect
                        fill="#D8D8D8"
                        opacity="0"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      ></rect>
                      <path
                        d="M6.52709989,8.22855231 L9.35440141,7.85218201 C11.1103508,7.61843008 12.889573,7.6190015 14.6453718,7.85388129 L17.4495198,8.22900266 C18.3350853,8.34746584 19.0346597,9.03892527 19.1634491,9.92304802 C19.7211497,13.7515915 20,16.1105755 20,17 C19.8207446,17.2863471 19.6038501,17.5684418 19.3493163,17.846284 C18.6717831,18.5858321 17.5512591,18.7091823 16.7290881,18.1347108 L15.6211333,17.3605549 C15.2852438,17.1258604 14.8853717,17 14.4756117,17 L9.68395185,17 C9.29299444,17 8.91060973,17.114585 8.58407949,17.3295866 L7.25342275,18.2057486 C6.42863319,18.7488292 5.33092558,18.6086212 4.66912002,17.8756629 C4.4219613,17.6019314 4.19892129,17.3100438 4,17 C4,16.1590018 4.27007338,13.8038539 4.81022014,9.93455637 C4.93441552,9.04483543 5.63660812,8.34709455 6.52709989,8.22855231 Z"
                        stroke={colors.text}
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                      ></path>
                      <line
                        x1="15.0071521"
                        y1="6.00322637"
                        x2="17.9814489"
                        y2="6.46175853"
                        stroke={colors.text}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></line>
                      <line
                        x1="6.03517406"
                        y1="6.00322637"
                        x2="8.98824921"
                        y2="6.46175853"
                        stroke={colors.text}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform="translate(7.511712, 6.232492) scale(1, -1) translate(-7.511712, -6.232492)"
                      ></line>
                      <line
                        x1="8.98543266"
                        y1="11.0778621"
                        x2="8.98543266"
                        y2="13"
                        stroke={colors.text}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform="translate(8.985433, 12.038931) scale(1, -1) translate(-8.985433, -12.038931)"
                      ></line>
                      <line
                        x1="14.9854327"
                        y1="11.0778621"
                        x2="14.9854327"
                        y2="13"
                        stroke={colors.text}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform="translate(14.985433, 12.038931) scale(1, -1) translate(-14.985433, -12.038931)"
                      ></line>
                      <line
                        x1="11.9854327"
                        y1="13.0778621"
                        x2="11.9854327"
                        y2="14.0389311"
                        stroke={colors.text}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform="translate(11.985433, 13.558397) scale(1, -1) translate(-11.985433, -13.558397)"
                      ></line>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        ) : (
          // 如果没有用户名，只在右上角显示主题切换按钮
          toggleTheme && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 16,
              }}
            >
              <Button
                type="text"
                size="large"
                icon={
                  isDark ? (
                    <BulbOutlined
                      style={{ fontSize: 20, color: colors.text }}
                    />
                  ) : (
                    <MoonOutlined
                      style={{ fontSize: 20, color: colors.text }}
                    />
                  )
                }
                onClick={toggleTheme}
                style={{ width: 40, height: 40 }}
              />
            </div>
          )
        )}

        <Title level={2} style={styles.title}>
          {displayData?.title ||
            intl.formatMessage({
              id: "category.select.title",
              defaultMessage: "请选择咨询类型",
            })}
        </Title>

        <Text style={styles.subtitle}>
          {displayData?.desc ||
            intl.formatMessage({
              id: "category.select.subtitle",
              defaultMessage: "选择您要咨询的问题类型，我们将为您提供更精准的服务",
            })}
        </Text>

        {/* 两列网格布局，一屏展示全部分类 */}
        <div style={styles.mainContainer}>
          <div style={styles.categoryGrid}>
          {hasConfigs &&
            (displayData!.configs || []).map((config, index) => {
            const isSelected = selectedCategory === config;
            const iconComponent = ICON_MAP[config.icon] || (
              <CreditCardOutlined />
            );

            const isDark = colors.background === "#14172B";
            return (
              <div key={index} style={{ minWidth: 0 }}>
                <div
                  data-card-wrapper
                  style={styles.cardWrapper({
                    isSelected,
                    color: config.color,
                    isDark,
                  })}
                  onMouseEnter={(e) => {
                    // 所有情况下都触发 hover 效果
                    e.currentTarget.style.transform = "translateY(-4px)";
                    // hover 时增强阴影效果
                    const outerBorder = e.currentTarget.querySelector(
                      "[data-outer-border]"
                    ) as HTMLElement;
                    if (outerBorder) {
                      if (isSelected) {
                        // 选中状态下使用主题色增强阴影
                        outerBorder.style.boxShadow = `0 8px 25px ${config.color}60, 0 0 0 1px ${config.color}40`;
                      } else {
                        // 未选中状态下使用普通增强阴影（亮色和暗色模式都生效）
                        outerBorder.style.boxShadow = `0 8px 25px ${colors.shadow}`;
                      }
                    }
                  }}
                  onMouseLeave={(e) => {
                    // 所有情况下都恢复原始效果
                    e.currentTarget.style.transform = "translateY(0)";
                    const outerBorder = e.currentTarget.querySelector(
                      "[data-outer-border]"
                    ) as HTMLElement;
                    if (outerBorder) {
                      if (isSelected) {
                        // 选中状态下恢复为带主题色的阴影
                        outerBorder.style.boxShadow = `0 2px 8px ${colors.shadow}, 0 0 0 1px ${config.color}40`;
                      } else {
                        // 未选中状态下恢复为普通阴影
                        outerBorder.style.boxShadow = `0 2px 8px ${colors.shadow}`;
                      }
                    }
                  }}
                >
                  {/* 外部div - 使用#73E6FF边框 */}
                  <div
                    data-outer-border
                    style={styles.cardOuterBorder({
                      isSelected,
                      color: config.color,
                      isDark,
                    })}
                  />
                  {/* 内部div - 向上和右偏移，使用渐变色背景 */}
                  <div
                    data-inner-border
                    style={styles.cardInnerBorder({
                      isSelected,
                      color: config.color,
                      isDark,
                    })}
                  />
                  {/* 内容卡片 - 在最上层 */}
                  <Card
                    hoverable
                    style={styles.categoryCard({
                      isSelected,
                      color: config.color,
                    })}
                    bodyStyle={styles.cardBody(!!screens.xs)}
                    onClick={(e) => {
                      // 添加点击反馈效果（移动端和桌面端都生效）
                      const cardElement = e.currentTarget;
                      cardElement.style.transform = "scale(0.98)";
                      setTimeout(() => {
                        cardElement.style.transform = "";
                      }, 150);
                      handleCategoryClick(config);
                    }}
                    onTouchStart={(e) => {
                      // 移动端触摸时触发反馈效果
                      e.stopPropagation(); // 阻止事件冒泡，避免冲突
                      const cardElement = e.currentTarget;
                      const wrapperElement = cardElement.closest(
                        "[data-card-wrapper]"
                      ) as HTMLElement;

                      // Card 缩放效果
                      cardElement.style.transform = "scale(0.98)";

                      // 外层 wrapper 上移和阴影效果
                      if (wrapperElement) {
                        wrapperElement.style.transform = "translateY(-2px)";
                        const outerBorder = wrapperElement.querySelector(
                          "[data-outer-border]"
                        ) as HTMLElement;
                        if (outerBorder) {
                          if (isSelected) {
                            outerBorder.style.boxShadow = `0 6px 20px ${config.color}60, 0 0 0 1px ${config.color}40`;
                          } else {
                            outerBorder.style.boxShadow = `0 6px 20px ${colors.shadow}`;
                          }
                        }
                      }
                    }}
                    onTouchEnd={(e) => {
                      // 移动端触摸结束时恢复
                      e.stopPropagation();
                      const cardElement = e.currentTarget;
                      const wrapperElement = cardElement.closest(
                        "[data-card-wrapper]"
                      ) as HTMLElement;

                      setTimeout(() => {
                        // Card 恢复
                        cardElement.style.transform = "";

                        // 外层 wrapper 恢复
                        if (wrapperElement) {
                          wrapperElement.style.transform = "translateY(0)";
                          const outerBorder = wrapperElement.querySelector(
                            "[data-outer-border]"
                          ) as HTMLElement;
                          if (outerBorder) {
                            if (isSelected) {
                              outerBorder.style.boxShadow = `0 2px 8px ${colors.shadow}, 0 0 0 1px ${config.color}40`;
                            } else {
                              outerBorder.style.boxShadow = `0 2px 8px ${colors.shadow}`;
                            }
                          }
                        }
                      }, 150); // 短暂延迟，让用户看到反馈
                    }}
                  >
                    {/* 选中标记 - 右上角 */}
                    {isSelected && (
                      <div
                        style={{
                          position: "absolute",
                          top: screens.xs ? "8px" : "12px",
                          right: screens.xs ? "8px" : "12px",
                          width: screens.xs ? "20px" : "24px",
                          height: screens.xs ? "20px" : "24px",
                          borderRadius: "50%",
                          background: config.color,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 10,
                          boxShadow: `0 2px 8px ${config.color}50`,
                          pointerEvents: "none", // 不阻挡点击事件
                          transition: "all 0.3s ease", // 添加过渡效果
                        }}
                      >
                        <CheckCircleOutlined
                          style={{
                            fontSize: screens.xs ? "14px" : "16px",
                            color: "#fff",
                          }}
                        />
                      </div>
                    )}
                    <div style={styles.icon(!!screens.xs, config.color)}>
                      {iconComponent}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        textAlign: "left",
                        flex: 1,
                        minWidth: 0,
                        width: "100%",
                      }}
                    >
                      <Title
                        level={5}
                        style={{
                          ...styles.cardTitle(
                            !!screens.xs,
                            isSelected,
                            config.color
                          ),
                          textAlign: "left",
                        }}
                      >
                        {config.name}
                      </Title>

                      <Text
                        style={{
                          ...styles.cardDesc(!!screens.xs),
                          textAlign: "left",
                        }}
                      >
                        {config.description}
                      </Text>
                    </div>
                  </Card>
                </div>
              </div>
            );
          })}
          {onStartWithoutCategory && (
            <div style={{ gridColumn: "1 / -1", marginTop: hasConfigs ? 4 : 0 }}>
              <Button
                block
                type={hasConfigs ? "default" : "primary"}
                size="middle"
                onClick={onStartWithoutCategory}
                style={{
                  height: 40,
                  borderRadius: 10,
                  fontSize: 14,
                }}
              >
                {intl.formatMessage({
                  id: "chat.direct_chat",
                  defaultMessage: "直接开始对话",
                })}
              </Button>
            </div>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryReplyPreview;
